import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './Settings.module.css';

export type SettingsSectionProps = {
  id: string;
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
  children: ReactNode;
};

export const SettingsSection = ({
  id,
  icon: Icon,
  title,
  description,
  action,
  children,
}: SettingsSectionProps) => (
  <section id={id} tabIndex={-1} aria-labelledby={`${id}-title`} className={styles['section']}>
    <header className={styles['sectionHead']}>
      <span className={styles['sectionIcon']} aria-hidden="true">
        <Icon size={20} />
      </span>
      <div className={styles['sectionText']}>
        <h2 id={`${id}-title`}>{title}</h2>
        <p className={styles['muted']}>{description}</p>
      </div>
      {action}
    </header>
    {children}
  </section>
);
